import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FieldArrayWithId } from 'react-hook-form/dist/types/fieldArray';

import Box from '@mui/material/Box';

import { useFieldArrayContext } from 'components/shared/CRUD/components/InnerPage/hooks/useFieldArrayContext';
import useFindIndexFromFieldsArray from 'components/shared/CRUD/hooks/useFindIndexFromFieldsArray';
import {
  ControlledDatePicker,
  ControlledSelect
} from 'components/shared/ControlledFields';

const getLastAddedFieldId = (fields: FieldArrayWithId[]) =>
  fields.slice(-1)[0]?.id;

const EditAccount = ({ rowId, userOptions }) => {
  const { control } = useFormContext();
  const { fields } = useFieldArrayContext();
  const fieldIndex = useFindIndexFromFieldsArray(
    rowId ?? getLastAddedFieldId(fields),
    fields
  );

  const isInEditMode = !!rowId;

  const { t } = useTranslation('common');

  return (
    <Box width={'100%'}>
      <Box mb={2.5} width={'100%'}>
        <ControlledSelect
          name={`accounts[${fieldIndex}].accountId`}
          label={t('api_accounts.accountName')}
          options={userOptions}
          control={control}
          disabled={isInEditMode}
        />
      </Box>
      <Box mb={2.5} width={'100%'}>
        <ControlledDatePicker
          control={control}
          name={`accounts[${fieldIndex}].valid.from`}
          label={t('validFrom')}
          fullWidth={true}
        />
      </Box>
      <Box mb={2.5} width={'100%'}>
        <ControlledDatePicker
          control={control}
          name={`accounts[${fieldIndex}].valid.to`}
          label={t('validTo')}
          fullWidth={true}
        />
      </Box>
    </Box>
  );
};

export default EditAccount;
